import script from "./flex-grid.vue?vue&type=script&lang=js"
export * from "./flex-grid.vue?vue&type=script&lang=js"

import "./flex-grid.vue?vue&type=style&index=0&id=52f030b3&lang=scss"

const __exports__ = script;

export default __exports__